import React from 'react';
import './Loader.css';

const LoaderElement = () => {
  return (
    <>
      <div className="loading-overlay">
        <div className="d-flex align-items-center justify-content-center">
          <div className="position-relative rounded-3 d-flex align-items-center justify-content-center text-white fw-bold shadow-lg zoomey-logo-animation loading-logo" >
            <span className="loader-logo-character">Z</span>
          </div>

          <div className="d-flex align-items-center loading-letters" >
            <span className="loader-character letter-z">Z</span>
            <span className="loader-character letter-o1">O</span>
            <span className="loader-character letter-o2">O</span>
            <span className="loader-character letter-m">M</span>
            <span className="loader-character letter-e">E</span>
            <span className="loader-character letter-y">Y</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoaderElement;